<template>
<div class="chapter">
<div class="inner_page">
<p class="head" id="pre"><a href="#/Contents#rpre">P<span class="small">REFACE</span></a></p>
<p class="indent1"><span class="dropcap">T</span><span class="small">HE MANY EDUCATORS AND</span></p>
<p class="indent2">parents with whom I have talked in recent years have convinced me, by their questions and comments, that the ideas in this book are of great concern to them. The volume itself is a collection of short pieces, many of which have appeared separately in pamphlets, magazines, and books. In some I have made cuts; others I have substantially rewritten; the remainder have been included in their original version. Since this collection may be useful in different ways to many people, it seemed a good idea to make it available as quickly as possible.</p>
<p class="indent">Many of our schools, and many people and things in our schools, are changing rapidly. So are my ideas as well. Thus, I have here and there added a short insertion or afterword when it seemed necessary to take account of important changes, either in education or in my own thinking.</p>
<p class="indent">I would like to thank the Center for the Study of Democratic Institutions, Doubleday, <i>Harper’s Magazine, Life, New York Review of Books, New York Times Magazine, the PTA Magazine, Redbook, </i>Sterling Institute, and <i>Yale Alumni Magazine </i>who first published some of these pieces and who have made it possible for me to bring them together in this book.</p>
<p class="right">—John Holt<br/>Berkeley, California</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface.vue?1e881c34